import { Icon } from '@zillow/constellation-10';
import { IconChevronDownCircleOutline } from '@zillow/constellation-icons';
import * as S from './styles';

const MoreButton = (props = {}) => {
  const handleClick = () => {
    window.scroll({
      top: props.scrollTop || 782,
      left: 0,
      behavior: 'smooth',
    });
  };

  return (
    <S.PlacementWrapper>
      <div onClick={handleClick}>
        <Icon size="lg" css={{ color: 'icon.onHero.neutral' }} render={<IconChevronDownCircleOutline />} />
      </div>
      <S.Text>MORE</S.Text>
    </S.PlacementWrapper>
  );
};

export default MoreButton;
